// Build-time settings. Production values (all public) are in apps/crm/.env.production; secrets never go in the repo.
export const env = {
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL ?? "").replace(/\/+$/, ""),
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? "",
  enableGoogle: String(import.meta.env.VITE_ENABLE_GOOGLE ?? "false").toLowerCase() === "true",
  // Trading-name disclosure (UK Companies Act rules): set VITE_LEGAL_FOOTER to the full line with the company
  // number and registered office, e.g. "Ogma Hub is a trading name of Heimdall Partners Ltd, registered in ...".
  legalFooter: (import.meta.env.VITE_LEGAL_FOOTER ?? "Ogma Hub is a trading name of Heimdall Partners Ltd.").trim(),
};

export const isConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);

export function functionUrl(name: string, base = env.supabaseUrl): string {
  return `${base}/functions/v1/${name}`;
}
